import { ListBoxChangeEvent } from "primereact/listbox";
import { useState } from "react";

import { Products } from "../../Domain/Model/Products";


import { PaginationResult } from "../../../../Shared/Model/PaginationResult";

import OffersPromoAPIDataSourceImpl from "../../Data/DataSource/API/OffersPromoAPIDataSource";
import { OffersPromoRepositoryImpl } from "../../Data/Repository/OffersPromoRepositoryImpl";

import { BannerState } from "../../Domain/Model/BannerState";
import { BannerItemsOrder, Banners } from "../../Domain/Model/Banners";
import { CreateBanner } from "../../Domain/UseCase/CreateBanner";
import { GetBannerById } from "../../Domain/UseCase/GetBannerById";
import { GetBanners } from "../../Domain/UseCase/GetBanners";
import { GetProducts } from "../../Domain/UseCase/GetProducts";
import { UpdateStateBanner } from "../../Domain/UseCase/UpdateStateBanner";

import { UpdateBannerList } from "../../Domain/UseCase/UpdateBannerList";

import { Banner } from "../../Domain/Model/Banner";
import { Modals } from "../../Domain/Model/Modal/Modals";
import { OfferState } from "../../Domain/Model/OfferState";
import { OfferItemsOrder, Offers } from "../../Domain/Model/Offers";
import { PromoBars } from "../../Domain/Model/PromoBar/PromoBars";
import { CreateModal } from "../../Domain/UseCase/CreateModal";
import { CreateOffer } from "../../Domain/UseCase/CreateOffer";
import { GetModalById } from "../../Domain/UseCase/GetModalById";
import { GetModals } from "../../Domain/UseCase/GetModals";
import { GetOfferImagesById } from "../../Domain/UseCase/GetOfferImagesById";
import { GetOfferItemSliderById } from "../../Domain/UseCase/GetOfferItemSliderById";
import { GetOfferSliderById } from "../../Domain/UseCase/GetOfferSliderById";
import { GetOfferTimerById } from "../../Domain/UseCase/GetOfferTimerById";
import { GetOffers } from "../../Domain/UseCase/GetOffers";
import { CreatePromoBar } from "../../Domain/UseCase/PromoBar/CreatePromoBar";
import { GetPromoBarById } from "../../Domain/UseCase/PromoBar/GetPromoBarById";
import { GetPromoBars } from "../../Domain/UseCase/PromoBar/GetPromoBars";
import { RemovePromoBarItemTable } from "../../Domain/UseCase/PromoBar/RemovePromoBarItemTable";
import { UpdatePromoBar } from "../../Domain/UseCase/PromoBar/UpdatePromoBar";
import { UpdateStatePromoBar } from "../../Domain/UseCase/PromoBar/UpdateStatePromoBar";
import { RemoveBannerItemTable } from "../../Domain/UseCase/RemoveBannerItemTable";
import { RemoveModalItemTable } from "../../Domain/UseCase/RemoveModalItemTable";
import { RemoveOfferItem } from "../../Domain/UseCase/RemoveOfferItem";
import { RemoveOfferItemTable } from "../../Domain/UseCase/RemoveOfferItemTable";
import { RemoveOfferRow } from "../../Domain/UseCase/RemoveOfferRow";
import { UpdateBannerSingle } from "../../Domain/UseCase/UpdateBannerSingle";
import { UpdateDarkMode } from "../../Domain/UseCase/UpdateDarkMode";
import { UpdateItemOffer } from "../../Domain/UseCase/UpdateItemOffer";
import { UpdateModalList } from "../../Domain/UseCase/UpdateModalList";
import { UpdateModalSingle } from "../../Domain/UseCase/UpdateModalSingle";
import { UpdateOfferImages } from "../../Domain/UseCase/UpdateOfferImages";
import { UpdateOfferList } from "../../Domain/UseCase/UpdateOfferList";
import { UpdateOfferSingle } from "../../Domain/UseCase/UpdateOfferSingle";
import { UpdateSliderOffer } from '../../Domain/UseCase/UpdateSliderOffer';
import { UpdateStateModal } from "../../Domain/UseCase/UpdateStateModal";
import { UpdateStateOffer } from "../../Domain/UseCase/UpdateStateOffer";
import { UpdateTableOffer } from "../../Domain/UseCase/UpdateTableOffer";
import { UpdateTableBanner } from "../../Domain/UseCase/UpdateTablebanner";
import { UpdateTimer } from "../../Domain/UseCase/UpdateTimer";



export default function OffersPromoViewModel() {

  const [products, setProducts] = useState<Products[]>([]);
  const [banners, setBanners] = useState<Banners[]>([]);
  const [modals, setModals] = useState<Modals[]>([]);
   const [promoBars, setPromoBars] = useState<PromoBars[]>([]);

  const [offers, setOffers] = useState<Offers[]>([]);
  const [checkedStates, setCheckedStates] = useState<Record<number, boolean>>({});

  const offersPromoDataSourceImpl = new OffersPromoAPIDataSourceImpl();
  const offersPromoRepositoryImpl = new OffersPromoRepositoryImpl( offersPromoDataSourceImpl);

  const getBannersUseCase = new GetBanners(offersPromoRepositoryImpl);
  const getBannerByIdUseCase = new GetBannerById(offersPromoRepositoryImpl);
  const createBannerUseCase = new CreateBanner(offersPromoRepositoryImpl);

  const updateStateBannerUseCase = new UpdateStateBanner(offersPromoRepositoryImpl);
  const updateBannerListUseCase = new UpdateBannerList(offersPromoRepositoryImpl);
  const updateBannerSingleUseCase = new UpdateBannerSingle(offersPromoRepositoryImpl);
  const updateTableBannerUseCase = new UpdateTableBanner(offersPromoRepositoryImpl);
  const removeBannerItemTableUseCase = new RemoveBannerItemTable(offersPromoRepositoryImpl);
  

  const getProductsUseCase = new GetProducts(offersPromoRepositoryImpl);

  const getOffersUseCase = new GetOffers(offersPromoRepositoryImpl);
  const createOfferUseCase = new CreateOffer(offersPromoRepositoryImpl);
  const updateStateOfferUseCase = new UpdateStateOffer(offersPromoRepositoryImpl);
  const updateTableOfferUseCase = new UpdateTableOffer(offersPromoRepositoryImpl);
  const updateSliderOfferUseCase = new UpdateSliderOffer(offersPromoRepositoryImpl);


  const getOfferImagesByIdUseCase = new GetOfferImagesById(offersPromoRepositoryImpl);
  const getOfferSliderByIdUseCase = new GetOfferSliderById(offersPromoRepositoryImpl);
  const getOfferTimerByIdUseCase = new GetOfferTimerById(offersPromoRepositoryImpl);

  const removeOfferRowUseCase = new RemoveOfferRow(offersPromoRepositoryImpl);
  const removeOfferItemUseCase = new RemoveOfferItem(offersPromoRepositoryImpl);
  const updateItemOfferUseCase = new UpdateItemOffer(offersPromoRepositoryImpl);
  const updateOfferImagesUseCase = new UpdateOfferImages(offersPromoRepositoryImpl);

  const updateOfferListUseCase = new UpdateOfferList(offersPromoRepositoryImpl);
  const updateOfferSingleUseCase = new UpdateOfferSingle(offersPromoRepositoryImpl);
  
  const getOfferItemSliderByIdUseCase = new GetOfferItemSliderById(offersPromoRepositoryImpl);
  const updateDarkModeUseCase = new UpdateDarkMode(offersPromoRepositoryImpl);
  const updateTimerUseCase = new UpdateTimer(offersPromoRepositoryImpl);

  const removeOfferItemTableUseCase = new RemoveOfferItemTable(offersPromoRepositoryImpl);

  //MODAL
  const getModalsUseCase = new GetModals(offersPromoRepositoryImpl);
  const getModalByIdUseCase = new GetModalById(offersPromoRepositoryImpl);
  const createModalUseCase = new CreateModal(offersPromoRepositoryImpl);

  const updateStateModalUseCase = new UpdateStateModal(offersPromoRepositoryImpl);
  const updateModalListUseCase = new UpdateModalList(offersPromoRepositoryImpl);
  const updateModalSingleUseCase = new UpdateModalSingle(offersPromoRepositoryImpl);
  const removeModalItemTableUseCase = new RemoveModalItemTable(offersPromoRepositoryImpl);

  //PROMOBAR
  const getPromoBarsUseCase = new GetPromoBars(offersPromoRepositoryImpl);
  const getPromoBarByIdUseCase = new GetPromoBarById(offersPromoRepositoryImpl);
  const createPromoBarUseCase = new CreatePromoBar(offersPromoRepositoryImpl);

  const updateStatePromoBarUseCase = new UpdateStatePromoBar(offersPromoRepositoryImpl);
  const updatePromoBarUseCase = new UpdatePromoBar(offersPromoRepositoryImpl);
  const removePromoBarItemTableUseCase = new RemovePromoBarItemTable(offersPromoRepositoryImpl);


    async function getBanners(page: number, size: number, search: string): Promise<{ items: Banners[]; totalCount: number }> {
      try {
        const result: PaginationResult<Banners> = await getBannersUseCase.invoke(page, size, search );
    
        await setBanners(result.items); // Si quieres mantenerlo en el ViewModel
        setCheckedStates(
          result.items.reduce((acc, banner) => {
            acc[banner.id] = banner.status === 0;
            return acc;
          }, {} as Record<number, boolean>)
        );
    
        return {
          items: result.items,
          totalCount: result.totalCount, // usar totalCount según tu interfaz
        };
      } catch (error) {
        console.error("Error al obtener productos:", error);
        return { items: [], totalCount: 0 };
      }
    }

    async function getBannerById(id: number) {
        try {
          const Banner = await getBannerByIdUseCase.invoke(id);
          if (Banner) {
            return Banner;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function createBanner(data: any) {
         
        try {
          const created = await createBannerUseCase.invoke(data);
          if(created){
            return created;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
    }

    async function updateStateBanner(data: BannerState) {
        try {
          const updated = await updateStateBannerUseCase.invoke(data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function removeBannerItemTable(bannerId : number){
       try {
          const deleted = await removeBannerItemTableUseCase.invoke(bannerId);
          if (deleted) {
           
            return deleted;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }
    
    async function updateStateOffer(data: OfferState) {
        try {
          const updated = await updateStateOfferUseCase.invoke(data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }
    

    async function updateTableOffers(data: OfferItemsOrder[]) {
      try {
        const updated = await updateTableOfferUseCase.invoke(data);
        if(updated){
          return updated;
        }
        //_resetValue();
      } catch (e) {
        //_resetValue();
        if (e instanceof Error) {
          console.log(e.message);
        }
        return Error;
      }
    }

    async function updateSliderOffer(itemId: number, data: any){
      try {
          const updated = await updateSliderOfferUseCase.invoke(itemId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      
    }

    async function updateTableBanner(data: BannerItemsOrder[]) {
      try {
        const updated = await updateTableBannerUseCase.invoke(data);
        if(updated){
          return updated;
        }
        //_resetValue();
      } catch (e) {
        //_resetValue();
        if (e instanceof Error) {
          console.log(e.message);
        }
        return Error;
      }
    }

    async function updateBannerList(idBanner: number, data: FormData) {
        try {
          const updated = await updateBannerListUseCase.invoke(idBanner, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateBannerSingle(idBanner: number, data: FormData) {
        try {
          const updated = await updateBannerSingleUseCase.invoke(idBanner, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    function onChangeProduct(e: ListBoxChangeEvent) {
        e.preventDefault();
        setProducts(e.target.value);
    }
    const handleSwitchChange = async (checked: boolean, id: number, typeStateUpdate: string): Promise<void> => {
         // Guardamos el estado anterior en caso de error
        const previousState = checkedStates[id];

        console.log(`Intentando actualizar estado para ID ${id} a ${checked} (Tipo: ${typeStateUpdate})`);

        // Actualizamos el estado en la UI inmediatamente para una mejor experiencia
        setCheckedStates((prevStates) => ({
          ...prevStates,
          [id]: checked,
        }));

        const stateUpdateBanner: BannerState = {
          bannerId: id,
          status: checked ? 0 : 1,
        };

        const stateUpdateOffer: OfferState = {
          offerId: id,
          status: checked ? 0 : 1,
        };

       let data = null;

       if(typeStateUpdate==="banner"){
          data = updateStateBanner(stateUpdateBanner)
       }else if(typeStateUpdate==="offer"){
          data = updateStateOffer(stateUpdateOffer)
       }else if(typeStateUpdate==="modal"){
          data = updateStateModal(id)
       }else if(typeStateUpdate==="promoBar"){
           data = updateStatePromoBar(id)
        } else {
        console.warn("Tipo de actualización no reconocido. No se realizará ninguna acción.");
       }

        const success = await data;

        if (!success) {
          console.warn("No se pudo actualizar el estado en la base de datos. Revirtiendo cambio...");
          setCheckedStates((prevStates) => ({
            ...prevStates,
            [id]: previousState,
          }));
        }
    };

    async function getProducts(page: number, size: number, search: string): Promise<{ items: Products[]; totalCount: number }> {
      try {
        const result: PaginationResult<Products> = await getProductsUseCase.invoke(page, size, search );
    
        await setProducts(result.items); // Si quieres mantenerlo en el ViewModel
       
    
        return {
          items: result.items,
          totalCount: result.totalCount, // usar totalCount según tu interfaz
        };
      } catch (error) {
        console.error("Error al obtener productos:", error);
        return { items: [], totalCount: 0 };
      }
    }

    async function getOffers(page: number, size: number, search: string, typeOfferImage: number): Promise<{ items: Offers[]; totalCount: number }> {
      try {
        const result: PaginationResult<Offers> = await getOffersUseCase.invoke(page, size, search, typeOfferImage);
    
        await setOffers(result.items); // Si quieres mantenerlo en el ViewModel
        setCheckedStates(
          result.items.reduce((acc, offer) => {
            acc[offer.id] = offer.status === 0;
            return acc;
          }, {} as Record<number, boolean>)
        );
    
        return {
          items: result.items,
          totalCount: result.totalCount, // usar totalCount según tu interfaz
        };
      } catch (error) {
        console.error("Error al obtener productos:", error);
        return { items: [], totalCount: 0 };
      }
    }

    async function createOffer(data: any) {
         
        try {
          const created = await createOfferUseCase.invoke(data);
          if(created){
            return created;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
    }

    async function getImagesById(id: number) {
        try {
          const offer = await getOfferImagesByIdUseCase.invoke(id);
          if (offer) {
            return offer;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function getSliderById(id: number) {
        try {
          const offer = await getOfferSliderByIdUseCase.invoke(id);
          if (offer) {
            return offer;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function getTimerById(id: number) {
        try {
          const offer = await getOfferTimerByIdUseCase.invoke(id);
          if (offer) {
            return offer;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function removeOfferRow(offerId : number, rowId : string){
      try {
          const deleted = await removeOfferRowUseCase.invoke(offerId, rowId);
          if (deleted) {
           
            return deleted;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function removeOfferItem( rowId : string, itemId : number){
       try {
          const deleted = await removeOfferItemUseCase.invoke(rowId, itemId);
          if (deleted) {
           
            return deleted;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateItemOffer(itemId: number, fromData: FormData ){
      try {
          const updated = await updateItemOfferUseCase.invoke(itemId, fromData);
          if (updated) {
           
            return updated;
          }
          //_resetValue();
      } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
      }
    }

    async function updateOfferImages(offerId: number, data: any ){
      
      try {
          const updated = await updateOfferImagesUseCase.invoke(offerId, data);
          if (updated) {
           
            return updated;
          }
          //_resetValue();
      } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
      }
    }

       async function updateOfferList(itemId: number, data: any) {
        try {
          const updated = await updateOfferListUseCase.invoke(itemId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateOfferSingle(itemId: number, data: any) {
        try {
          const updated = await updateOfferSingleUseCase.invoke(itemId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function getOfferItemSliderById(itemId: number){
      try {
          const data = await getOfferItemSliderByIdUseCase.invoke(itemId);
          if(data){
           return data;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateDarkMode(itemId: number, data: any) {
        try {
          const updated = await updateDarkModeUseCase.invoke(itemId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateTimer(itemId: number, data: any) {
        try {
          const updated = await updateTimerUseCase.invoke(itemId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function removeOfferItemTable(offerId : number){
       try {
          const deleted = await removeOfferItemTableUseCase.invoke(offerId);
          if (deleted) {
           
            return deleted;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }


    async function getModals(page: number, size: number, search: string): Promise<{ items: Modals[]; totalCount: number }> {
      try {
        const result: PaginationResult<Modals> = await getModalsUseCase.invoke(page, size, search );
    
        await setModals(result.items); // Si quieres mantenerlo en el ViewModel
        setCheckedStates(
          result.items.reduce((acc, modal) => {
            acc[modal.id] = modal.status === 0;
            return acc;
          }, {} as Record<number, boolean>)
        );
    
        return {
          items: result.items,
          totalCount: result.totalCount, // usar totalCount según tu interfaz
        };
      } catch (error) {
        console.error("Error al obtener productos:", error);
        return { items: [], totalCount: 0 };
      }
    }

    async function getModalById(id: number) {
        try {
          const Modal = await getModalByIdUseCase.invoke(id);
          if (Modal) {
            return Modal;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function createModal(data: any) {
         
        try {
          const created = await createModalUseCase.invoke(data);
          if(created){
            return created;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
    }

    async function updateStateModal(modalId: number) {
        try {
          const updated = await updateStateModalUseCase.invoke(modalId);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function removeModalItemTable(modalId : number){
       try {
          const deleted = await removeModalItemTableUseCase.invoke(modalId);
          if (deleted) {
           
            return deleted;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

     async function updateModalList(modalId: number, data: FormData) {
        try {
          const updated = await updateModalListUseCase.invoke(modalId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateModalSingle(modalId: number, data: FormData) {
        try {
          const updated = await updateModalSingleUseCase.invoke(modalId, data);
          if(updated){
           return updated;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function getPromoBars(page: number, size: number, search: string): Promise<{ items: PromoBars[]; totalCount: number }> {
      try {
        const result: PaginationResult<PromoBars> = await getPromoBarsUseCase.invoke(page, size, search );
    
        await setPromoBars(result.items);
        setCheckedStates(
          result.items.reduce((acc, promoBar) => {
            acc[promoBar.id] = promoBar.status === 0;
            return acc;
          }, {} as Record<number, boolean>)
        );
    
        return {
          items: result.items,
          totalCount: result.totalCount
        };
      } catch (error) {
        console.error("Error fetching promo bars:", error);
        return { items: [], totalCount: 0 };
      }
  }

    async function getPromoBarById(id: number) {
      try {
        const promoBar = await getPromoBarByIdUseCase.invoke(id);
        if (promoBar) {
          return promoBar;
        }
      } catch (e) {
        if (e instanceof Error) {
          console.log(e.message);
        }
      }
    }

    async function createPromoBar(data: any) {
        try {
          const created = await createPromoBarUseCase.invoke(data);
          if(created){
            return created;
          }
        } catch (e) {
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
    }

    async function updatePromoBar(promoBarId: number, data: FormData) {
        try {
          const updated = await updatePromoBarUseCase.invoke(promoBarId, data);
          if(updated){
           return updated;
          
          }
        } catch (e) {
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function updateStatePromoBar(promoBarId: number) {
        try {
          const updated = await updateStatePromoBarUseCase.invoke(promoBarId);
          if(updated){
           return updated;
          
          }
        } catch (e) {
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    async function removePromoBarItemTable(promoBarId : number){
       try {
          const deleted = await removePromoBarItemTableUseCase.invoke(promoBarId);
          if (deleted) {
            
            return deleted;
          }
        } catch (e) {
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
    }

    const updateOfferOrderLocal = (id: number, order: number) => {
        setOffers(prev =>
            prev.map(item =>
                item.id === id
                    ? {
                        ...item,
                        order
                    }
                    : item
            )
        );
    };

        const updateBannerOrderLocal = (id: number, order: number) => {
        setBanners(prev =>
            prev.map(item =>
                item.id === id
                    ? {
                        ...item,
                        order
                    }
                    : item
            )
        );
    };

      return {
        getBanners,
        banners,
        getBannerById,
        createBanner,
        onChangeProduct,
        checkedStates,
        handleSwitchChange,
        updateBannerList,
        updateBannerSingle,
        updateTableBanner,
        updateBannerOrderLocal,
        removeBannerItemTable,
        getProducts,
        products,
        setProducts,
        getOffers,
        updateOfferOrderLocal,
        offers,
        createOffer,
        updateTableOffers,
        updateSliderOffer,
        getImagesById,
        getSliderById,
        getTimerById,
        removeOfferRow,
        removeOfferItem,
        updateItemOffer,
        updateOfferImages,
        updateOfferList,
        updateOfferSingle,
        getOfferItemSliderById,
        updateDarkMode,
        updateTimer,
        removeOfferItemTable,
        getModalById,
        createModal,
        getModals,
        modals,
        updateStateModal,
        updateModalList,
        updateModalSingle,
        removeModalItemTable,
        getPromoBarById,
        createPromoBar,
        getPromoBars,
        promoBars,
        updatePromoBar,
        updateStatePromoBar,
        removePromoBarItemTable
      };
}